import { Chart } from 'chart.js';

export function isChartWithCategory(chart: Chart): boolean {
  const xAxisType = chart.scales?.['x']?.type;

  return xAxisType === 'category' || (!!chart.data.labels && !!chart.data.labels.length);
}

/**
 *
 * @description only for one dataset! If there are more, the range will be calculated only for the first one.
 *
 */
export function getCartRange(chart: Chart): { min: number; max: number } {
  const newRange = {
    min: 0,
    max: 0,
  };

  const dataset = chart.data.datasets[0]?.data;
  if (!dataset || dataset.length === 0) {
    return newRange;
  }

  if (isChartWithCategory(chart)) {
    const labelsCount = chart.data.labels ? chart.data.labels.length : dataset.length;
    newRange.min = 0;
    newRange.max = labelsCount;
  } else {
    const xValues: number[] = dataset.map(d => {
      if (!d) {
        return 0;
      }

      if (Array.isArray(d)) {
        return d[0];
      }

      if (typeof d === 'object') {
        return d.x;
      }

      return d;
    });

    newRange.min = Math.min(...xValues);
    newRange.max = Math.max(...xValues);
  }

  return newRange;
}
